export const GET_ROLES = 'app/store/role/GET_ROLES';
export const GET_ROLES_SUCCESS = 'app/store/role/GET_ROLES_SUCCESS';
export const GET_ROLES_ERROR = 'app/store/role/GET_ROLES_ERROR';
